import React, { useState, useEffect, useRef } from "react";
import { BaseDropdown, LargeButton, OverlayLoader } from "components/core";
import { Form, Formik } from "formik";
import { colors } from "theme";
import { products, roleIsAdmin } from "utlis/utils";
import UploadFile from "components/UploadFile";
import { Box, Divider } from "@mui/material";
import PremiumCalc from "./PremiumCalc";
import ErrorModal from "./ErrorModal";
import http from "services/httpService";
import { useNavigate } from "react-router-dom";
import OverlayModal from "./OverlayModal";
import { WidthLimiter } from "pages/PlanSetup/styles";

function AddDelete() {
  const [excelId, setExcelId] = useState("");
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [superTaskID, setSuperTaskID] = useState();
  const [taskDetail, setTaskDetail] = useState();
  const [loading, setLoading] = useState(false);
  const [premiumCalcDet, setPremiumCalc] = useState();
  const [userPlanId, setUserPlanId] = useState("");
  const [taskStatusSuccess, setTaskStatusSuccess] = useState(false);
  const [showSubmitBtn, setShowSubmitBtn] = useState(false);
  const [showPremiumSubmitBtn, setShowPremiumSubmitBtn] = useState(false)
  const [showProgressBarStatus, setShowProgressBarStatus] = useState(false);

  // for modal
  const [modalOpen, setModalOpen] = useState(false);
  const handleOpen = () => setModalOpen(true);
  const handleClose = () => setModalOpen(false);
  const modalContainerRef = useRef(null);

  useEffect(() => {
    if (modalOpen) {
      handleOpen();
    } else {
      handleClose();
    }
  }, [modalOpen]);

  const navigate = useNavigate();
  const intervalRef = useRef(null); // Use a ref to store the interval ID

  const options = products();
  const getOptions = (options) => {
    return options
      .filter((op) => op.label)
      .map((option) => ({
        ...option,
        title: option.label,
      }));
  };

  const getPremiumCalc = async (id, userplan_id) => {
    try {
      const { data } = await http.post(
        "/business/premium_calculation_for_employee/",
        {
          excel_file_id: id,
          userplan_id,
        }
      );
      setShowProgressBarStatus(true);
      setPremiumCalc(data);
    } catch (err) {
      console.err(err);
      alert("Some error has occured");
    }
  };

  useEffect(() => {
    if (taskStatusSuccess) {
      setTaskStatusSuccess(false);
      setLoading(false);
      setModalOpen(false);
      navigate("/v1/enrolments");
    }
  }, [taskStatusSuccess]);

  const getTaskStatusNoModal = (super_task_id) => {
    setShowProgressBarStatus(false);
    intervalRef.current = setInterval(async () => {
      const payload = {
        params: {
          super_task_id,
        },
      };
      const { data } = await http.get("business/get_taskset_details/", payload);
      setTaskDetail(data.task_set_data);
      if (data?.task_set_data?.status == "Failure") {
        setLoading(false);
        setModalOpen(false);
        console.log("# Error::get_taskset_details:", data);
        clearInterval(intervalRef.current);
        // alert("Internal Server Error")
      } else if (data?.task_set_data?.status == "Success") {
        setTaskStatusSuccess(true);
        clearInterval(intervalRef.current);
      }
    }, 1000 * 5);
  };

  const getTaskStatus = (id, super_task_id, userplan_id, rateChartValue) => {
    intervalRef.current = setInterval(async () => {
      const payload = {
        params: {
          super_task_id,
        },
      };
      const { data } = await http.get("business/get_taskset_details/", payload);
      setTaskDetail(data.task_set_data);
      if (data?.task_set_data?.status == "Failure") {
        setShowErrorModal(true);
        setLoading(false);
        setModalOpen(false);
        clearInterval(intervalRef.current);
      } else if (data?.task_set_data?.status == "Success") {
        if (rateChartValue) {
          console.log("# calculating premium....")
          await getPremiumCalc(id, userplan_id);
          setShowPremiumSubmitBtn(true)
        } else {
          console.log("# ignored premium calculation.")
          setShowPremiumSubmitBtn(true)
          setShowProgressBarStatus(true);
        }
        setLoading(false);
        setModalOpen(false);
        clearInterval(intervalRef.current);
      }
    }, 1000 * 5);
  };

  const getUserplan = (product) => {
    const products = JSON.parse(localStorage.getItem("products"));
    const selectedProduct = products[product];
    if (!selectedProduct) return null;
    return selectedProduct?.userplan;
  };

  const handleClientIDFileUpload = async (id, values) => {
    const allProducts = JSON.parse(localStorage.getItem("products"));
    const selectedProduct = allProducts[values?.policy_type];
    let rateChartValue = selectedProduct.userplan_data.rate_chart;

    if (id !== null && id !== undefined) {
      if (!values?.policy_type) {
        alert("Please select a policy");
        return;
      }

      // if (rateChartValue) {
      setExcelId(id);
      const userplan_id = getUserplan(values?.policy_type);
      setUserPlanId(userplan_id);
      const { data } = await http.post(
        "/business/validate_employee_endorsement/",
        {
          endorsement_file_id: id,
          userplan_id,
        }
      );
      setSuperTaskID(data);
      setLoading(true);
      setModalOpen(true);
      await getTaskStatus(id, data, userplan_id, rateChartValue);
      setShowSubmitBtn(true);
      // }
    }
  };

  useEffect(() => {
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);

  const endoresementHandler = async () => {
    try {
      const { data } = await http.post(
        "/business/save_employee_endorsement_info/",
        {
          endorsement_file_id: excelId,
          userplan_id: userPlanId,
        }
      );
      if (data) {
        getTaskStatusNoModal(data);
      } else {
        console.log("# Error::: Endorsement data not received.");
        // alert("Internal Server Error.")
      }
    } catch (error) {
      setLoading(false);
      setModalOpen(false);
      console.log("# Endorsement failed.", error);
    }
  };

  const onSubmitHandler = () => {
    setModalOpen(true);
    setLoading(true);
    setModalOpen(true);
    endoresementHandler();
  };

  const downloadAddDeleteEndorsementFormat = async (values) => {
    try {
      let get_userplan_id = getUserplan(values?.policy_type);
      if (get_userplan_id) {
        const { data } = await http.post(
          "business/download_file_format_for_add_delete_endorsement/",
          {
            userplan_id: get_userplan_id,
          }
        );  
        // if (data) {
        //   window.open(data.s3_url, "_blank");
        // }
        if (data?.s3_url) {
          const response = await fetch(data.s3_url);
          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
    
          const a = document.createElement("a");
          a.href = url;
          a.download = "Endorsement_Format.xlsx";
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        }
      } else {
        alert("Please select policy type.");
      }
    } catch (error) {
      console.log(
        "# Error API 'download_file_format_for_add_delete_endorsement' failed.",
        error
      );
    }
  };

  // if (loading) return <OverlayLoader />;

  return (
    <WidthLimiter>
      <div
        ref={modalContainerRef}
        style={{
          // maxWidth: "1000px",
          position: "relative",
        }}
      >

        {/* <button onClick={() => setModalOpen(true)}>open</button> */}
        <OverlayModal
          open={modalOpen}
          handleClose={handleClose}
          modalContainerRef={modalContainerRef}
        />

        <Formik
          initialValues={{
            policy_type: "",
          }}
          onSubmit={onSubmitHandler}
        >
          {(formikProps) => (
            <Form
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "2rem",
              }}
            >
              <header
                style={{
                  width: "500px",
                }}
              >
                <BaseDropdown
                  staticLabel="Select Policy Type"
                  fontSize="14"
                  fontColor={colors.defaultFontColor}
                  options={getOptions(options)}
                  formikProps={{ ...formikProps, name: "policy_type" }}
                  glassBorder={true}
                  dropdownIconColor="rgba(0, 0, 0, 0.54)"
                />
              </header>
              <UploadFile
                glassButtonEffect={true}
                headerMargin="12px 0"
                // label="Employee IDs"
                label="Upload Endorsement File"
                text="Upload File"
                sampleFile="UHID_sheet"
                uploadButtonText="Download Master Data"
                onDownload={() => {
                  downloadAddDeleteEndorsementFormat(formikProps.values);
                }}
                // onDownload={() => {
                //   window.open(
                //     "https://neoinsurance-backend-uploads-stage.s3.ap-south-1.amazonaws.com/neo_documents/frontend_sample_download_file/Endorsement_sheet_add_delete_final+1.xlsx"
                //   );
                // }}
                // showProgressBar={premiumCalcDet !== undefined}
                showProgressBar={showProgressBarStatus}
                format="excel"
                type="policy_upload_excel"
                onSelect={(id) => {
                  handleClientIDFileUpload(id, formikProps.values);
                }}
              //   fileName={setExcelFileName}
              />

              {/* {premiumCalcDet && ( */}
              <>
                {/* <Divider
                  sx={{
                    borderColor: "black",
                  }}
                /> */}
                <PremiumCalc premiumCalcDet={premiumCalcDet} showPremiumSubmitBtn={showPremiumSubmitBtn} />
              </>
              {/* )} */}
            </Form>
          )}
        </Formik>
        <ErrorModal
          open={showErrorModal}
          handleClose={() => setShowErrorModal(false)}
          downloadErrorFile={() => {
            if (!taskDetail?.async_tasks[0]?.error_file_path) {
              alert("No error file found");
              setShowErrorModal(false);
              return;
            }
            window.open(taskDetail?.async_tasks[0]?.error_file_path, "_blank");
            setShowErrorModal(false);
          }}
        />
      </div>

    </WidthLimiter>

  );
}

export default AddDelete;
